// removed by extract-text-webpack-plugin
module.exports = {"home":"home__3HqpU"};


//////////////////
// WEBPACK FOOTER
// ./routes/home/home.scss
// module id = eu3E
// module chunks = 0